import { motion } from "framer-motion";
import { EASE } from "./Motion";

const P = (d, stroke, w, delay) => (
  <motion.path
    d={d}
    stroke={stroke}
    strokeWidth={w}
    fill="none"
    strokeLinecap="round"
    initial={{ pathLength: 0 }}
    animate={{ pathLength: 1 }}
    transition={{ duration: 1.8, ease: EASE, delay }}
  />
);

export const Swoosh = ({ className = "" }) => (
  <svg viewBox="0 0 1200 700" preserveAspectRatio="none" className={className} aria-hidden="true">
    {P("M-80 640 C 320 600, 760 420, 1280 120", "#0B5323", 92, 0.2)}
    {P("M-80 700 C 360 660, 800 480, 1280 230", "#22FF00", 22, 0.45)}
    {P("M-80 560 C 300 520, 700 340, 1280 40", "#0B110D", 10, 0.6)}
  </svg>
);
